import { InternalIntegrationSetting } from 'models/InternalIntegrationSetting';
import Actions from './Actions';
import {
  ChannelListItemWrapper,
  LogoAndNameWrapper,
} from './ChannelListItem.styles';
import MetadataInfo from './MetadataInfo';

const ChannelListItem = ({
  channelIntegration,
}: {
  channelIntegration: InternalIntegrationSetting;
}) => {
  const {
    integration: { name, displayName, logo },
  } = channelIntegration;

  const channelName = displayName ?? name;

  return (
    <ChannelListItemWrapper>
      <LogoAndNameWrapper>
        <img
          src={logo}
          alt={`${channelName} logo`}
          width={24}
          height={24}
          loading="lazy"
        />
        <p>{channelName}</p>
      </LogoAndNameWrapper>

      <MetadataInfo />

      <Actions integration={channelIntegration} />
    </ChannelListItemWrapper>
  );
};

export default ChannelListItem;
